// @flow
import * as React from 'react';
import classnames from 'classnames/dedupe';

const Button = (props: { className: string, disabled?: boolean }) => {
  const { className: _className, disabled = undefined, ...rest } = props;

  return (
    <Btn
      disabled={disabled}
      render={({ getClassNames }) => (
        <button
          disabled={disabled}
          className={getClassNames(_className)}
          {...rest}
        />
      )}
    />
  );
};

Button.Primary = (props: { className?: string, disabled?: boolean }) => {
  const { className: _className, ...rest } = props;
  const className = classnames('bg-blue white', _className);
  return <Button className={className} {...rest} />;
};

Button.Ghost = props => {
  const { className: _className, ...rest } = props;
  const className = classnames('bg-white blue b--moon-gray', _className, {
    'b--black-025': false,
  });
  return <Button className={className} {...rest} />;
};

class Btn extends React.Component<{
  render: (*) => React.Node,
  disabled: ?boolean,
}> {
  getClassNames = (...classNameArgs) => {
    return classnames(
      'ba b--black-025 mid-gray bg-moon-gray br1 brandon button-reset input-reset f4 lh-title ph3 pv2',
      ...classNameArgs,
      {
        'o-50 not-allowed': this.props.disabled === true,
        'dim pointer': this.props.disabled !== true,
      }
    );
  };

  render() {
    return this.props.render({
      getClassNames: this.getClassNames,
    });
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Common/Button.js